import { DetailsCard, getRetailerLocation } from '@packages/ui/bmis/bmis-aside-details';
import { getLogger } from '@packages/core/logging';
import { qmrsService } from '@web/services/singletons';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView } from 'react-native';

const logger = getLogger('vin-sessions');

export const DMSAsideDetails: FC<{ retailerNumber: string; retailerName: string }> = ({
    retailerNumber,
    retailerName,
}) => {
    const { t } = useTranslation();
    const [retailerLocation, setRetailerLocation] = useState<string>('N/A');
    const [retailer, setRetailer] = useState<{ name: string; code: string } | null>(null);

    useEffect(() => {
        const fetchRetailer = async (retailerNumber: string) => {
            const response = await qmrsService.fetchRetailers({
                searchParams: { query: retailerNumber, canCreateQmr: true },
            });
            let retailer;
            if (
                response &&
                response.data &&
                'retailers' in response.data &&
                Array.isArray(response.data.retailers) &&
                response.data.retailers.length > 0
            ) {
                retailer = response.data.retailers[0];
            } else {
                retailer = null;
            }
            const retailerLocation = retailer ? getRetailerLocation(retailer) : '';
            setRetailerLocation(retailerLocation);
            setRetailer({ name: retailer?.name || 'N/A', code: retailer?.code || 'N/A' });
        };

        fetchRetailer(retailerNumber).catch((e) => {
            const message = e instanceof Error ? e.message : 'Failed to get retailers';
            logger.error(`Failed to fetch the retailer [${retailerNumber}]`, {
                error: e,
                retailerNumber,
                reason: message,
            });
        });
    }, [retailerNumber]);

    return (
        <ScrollView>
            <DetailsCard
                title={t('Retailer')}
                subTitle={retailer ? `${retailerName ?? retailer.name} (#${retailerNumber ?? retailer.code})` : 'N/A'}
                content={retailerLocation}
            />
        </ScrollView>
    );
};
